import { render, staticRenderFns } from "./MatrizRfmMonetario.vue?vue&type=template&id=24815fd0&"
import script from "./MatrizRfmMonetario.vue?vue&type=script&lang=js&"
export * from "./MatrizRfmMonetario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports